// These are utilities that might be helpful outside the scoring
// app. This provides a separate module that can be imported
// separately.

export const allLearnosityItems = items => items.every(
  item => item.format === 'js'
);

export const loadLanguageBundle = (locale, application) => {
    return import(
        /* webpackInclude: /\.json$/ */
        /* webpackExclude: /\.noimport\.json$/ */
        /* webpackChunkName: "learnositry-i18n" */
        /* webpackMode: "lazy" */
        /* webpackPrefetch: true */
        /* webpackPreload: true */
        `BubblesheetCore/i18n/languages/${resolveLocale(locale)}/label_bundles/${application}-api.json`)
        .then(module => module.default)
        .catch(error => {
            console.log("invalid locale code: ", locale, error);
            return {};
        });
}

const locales = {
    en: ["en-US", "en-GB"], // United States, United Kingdom
    es: ["es-ES"], // Spain
};

/**
 * Resolves a locale based on the input.
 *
 * @param {string} inputLocale - The input locale string (e.g., "en-US", "fr").
 * @returns {string|null} - The resolved locale or null if not found.
 */
function resolveLocale(inputLocale) {
    if (!inputLocale || typeof inputLocale !== 'string') {
        return null; // Handle invalid input
    }

    if (locales.hasOwnProperty(inputLocale.substring(0, inputLocale.indexOf('-')))) {
        const language = inputLocale.substring(0, inputLocale.indexOf('-'));
        const regions = locales[language];
        if (regions.includes(inputLocale)){
            return inputLocale;
        }
    }

    if (locales.hasOwnProperty(inputLocale)) {
        return locales[inputLocale][0];
    }

    if (inputLocale.includes('-')) {
        const languagePart = inputLocale.substring(0, inputLocale.indexOf('-'));
        if (locales.hasOwnProperty(languagePart)) {
            return locales[languagePart][0];
        }
    }

    return null; // Locale not found
}